// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"1a0f453c","702":"fbcdb9ec"}[chunkId] + ".chunk.js";
};